import { combineReducers } from '@reduxjs/toolkit';
import { e_switchListsbBy, I_RootState } from './interfaces';
import * as actionTypes from './actionTypes';
import { GroupReducer } from './Group/reducer';
import { AllReducer } from './All/reducer';
import { TicketReducer } from './Ticket/reducer';
import { VocationReducer } from './Vacation/reducer';
import { HotelReducer } from './Hotel/reducer';
import { FlightReducer } from './Flight/reducer';

// 全產品新增store 根據進階選項功能設立store，共通篩選功能參考price或destination
const initialState: I_RootState = {
    FilterItems: [],
    TempFilterItems: [],
    SortListBy: 0, // 排序值(api sortby)
    TagList: 'grp,vac,htl,etk,flt', // 館別 這預設是所有館別
    SwitchListBy: e_switchListsbBy.List, // 初始設為依行程列表 List
    AllCardsInfo: {
        DataList: [],
    },
    RecommendsData: [], // 查無資料時 推薦資料
    CityLength: {},
    FilterDataLoading: false,
    favList: [], //收藏list
    favPopUp: {
        state: 'addFav',
        show: false,
    },
    sendEmitApi: true,
};

const reducer = (state: I_RootState = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_FILTERITEMS:
            return { ...state, FilterItems: action.payload };
        case actionTypes.SET_TEMPFILTERITEMS:
            return { ...state, TempFilterItems: action.payload };
        case actionTypes.SET_SORTLISTBY:
            return { ...state, SortListBy: action.payload };
        case actionTypes.SET_TAGLIST:
            return { ...state, TagList: action.payload };
        case actionTypes.SET_SWITCHLISTBY:
            return { ...state, SwitchListBy: action.payload };
        case actionTypes.SET_PAGESIZEM:
            return { ...state, PageSizeM: action.payload };
        // 全產品卡牌資料設定
        case actionTypes.SET_CARDINFO: // 傳入 { datafilter的key : 選到的值 }
            return {
                ...state,
                AllCardsInfo: { ...action.payload },
            };
        // 全產品查無資料推薦用卡牌
        case actionTypes.SET_RECOMMENDS:
            return {
                ...state,
                RecommendsData: action.payload,
            };
        // 目的地篩選的所有城市跟初始城市合併後的city總數
        case actionTypes.SET_CITYLENGTH:
            return {
                ...state,
                CityLength: action.payload,
            };
        // 全產品推薦
        case actionTypes.SET_FAVLIST:
            return { ...state, favList: [...action.payload] };
        // 收藏提示框
        case actionTypes.SET_SHOWFAVPOPUP:
            return { ...state, favPopUp: { state: action.payload, show: true } };
        case actionTypes.SET_HIDEFAVPOPUP:
            return { ...state, favPopUp: { ...state.favPopUp, show: false } };
        // 全產品 mobile 一次發送篩選、排序、卡牌載入用
        case actionTypes.SET_MOBILE_EMIT_API:
            return { ...state, sendEmitApi: action.payload };
        case actionTypes.SET_FILTERDATALOADING:
            return { ...state, FilterDataLoading: action.payload };
        default:
            return state;
    }
};
const rootReducer = combineReducers({
    reducer,
    GroupReducer,
    HotelReducer,
    TicketReducer,
    VocationReducer,
    FlightReducer,
    AllReducer,
});
export default rootReducer;
export type State = ReturnType<typeof rootReducer>;
